import React from 'react';
const CTAButton = () => {
  return <a href="https://www.thaura.co/products/drift" className="block w-full cta-button" target="_blank" rel="noopener" data-id="element-222">
      <button className="bg-[#84f75d] hover:bg-[#6dd84a] text-black font-bold py-3.5 md:py-3 px-8 rounded-md w-full text-lg transition duration-300 mt-6 mb-6 md:mt-0 md:mb-0" data-id="element-223">
        Check Availability & Apply 50% OFF →
      </button>
    </a>;
};
export default CTAButton;